import Vue from 'vue';
import VueRouter from 'vue-router';
import Layouts from '@/layouts';
import { Roles, UserPermissions } from '@/config/userPermissions';
import customLocalStorage from '@/config/customLocalStorage';
import store from '@/store/index';
import ConfirmationPage from '@/components/wait-list/Parent/ConfirmationPage/ConfirmationPage.vue';
// Landing Home
const LandingHome = () => import('@/components/home-page/LandingHome.vue');
const LandingHomeAboutUs = () => import('@/components/home-page/AboutUs.vue');
const LandingHomeBlog = () => import('@/components/home-page/Blog.vue');
const LandingHomeBlogPost = () => import('@/components/home-page/BlogPost.vue');
const LandingHomeCareers = () => import('@/components/home-page/Careers.vue');
const LandingHomeHelpCenter = () => import('@/components/home-page/HelpCenter.vue');
const LandingHomeLicenses = () => import('@/components/home-page/Licenses.vue');
const LandingHomePress = () => import('@/components/home-page/Press.vue');
const LandingHomeSafetyCenter = () => import('@/components/home-page/SafetyCenter.vue');

const ApplicationHome = () => import('@/components/application-home/ApplicationHome.vue');
const Entry = () => import('@/views/entry/Entry.vue');
const EmailNotConfirmed = () => import('@/components/login/EmailNotConfirmed.vue');
const ResetPassword = () => import('@/components/login/ResetPassword.vue');
const ForgotPassword = () => import('@/components/login/ForgotPassword.vue');
const SurveyContainer = () => import('@/components/survey/SurveyContainer.vue');
const EnrollmentForm = () => import('@/components/enrollment-parent/EnrollmentForm.vue');
const Congratulations = () => import('@/components/menu-parent/05-referral-program/Congratulations.vue');
const InvitationLink = () => import('@/components/menu-parent/05-referral-program/InvitationLink.vue');
const EmptyRouterView = () => import('@/router/EmptyRouterView.vue');
const Settings = () => import('@/components/settings/Settings.vue');
const PaymentInfo = () => import('@/components/menu-parent/04-creditcard-info/PaymentInfo.vue');
const PaymentInfoStripe = () => import('@/components/menu-provider/04-payment-info/PaymentInfoStripe.vue');
const CreditCardsList = () => import('@/components/menu-parent/04-creditcard-info/CreditCardsList.vue');
const TermsOfUse = () => import('@/components/policies/TermsOfUse.vue');
const PrivacyPolicy = () => import('@/components/policies/PrivacyPolicy.vue');
const CookiePolicy = () => import('@/components/policies/CookiePolicy.vue');
const Login = () => import('@/components/login/Login.vue');
const Register = () => import('@/components/register/Register.vue');
const LetMeKnow = () => import('@/components/menu-parent/05-referral-program/LetMeKnow.vue');
const AdminIndex = () => import('@/components/admin/Index.vue');
const EditPrivacyPolicy = () => import('@/components/admin/EditPrivacyPolicy.vue');
const Error = () => import('@/components/Error.vue');
const ProgramStatement = () => import('@/components/enrollment-provider/3-program-statement/P3ProgramStatement.vue');
const EditProfile = () => import('@/components/profile/EditProfile.vue');
const Location = () => import('@/components/enrollment-provider/8-location/P8Location.vue');
const HomeSafety = () => import('@/components/enrollment-provider/6-home-safety/P6HomeSafety.vue');
const GetLocationAutomation = () => import('@/components/enrollment-provider/7-get-location/P7GetLocationAutomation.vue');
const FamilyAmenities = () => import('@/components/enrollment-provider/5-family-amenities/P5FamilyAmenities.vue');
const SettingsNotifications = () => import('@/components/enrollment-provider/17-settings-notification/P17SettingsNotifications.vue');
const PolicysAndProcedures = () => import('@/components/enrollment-provider/16-policies-and-procedures/P16PoliciesAndProcedures.vue');
const EditTermsOfUse = () => import('@/components/admin/EditTermsOfUse.vue');
const RegisterSupplement = () => import('@/components/register/RegisterSupplement.vue');
const StripeConnectedAccountLink = () => import('@/components/enrollment-provider/P1StripeConnectedAccountLink.vue');
const PropertyAndGuests = () => import('@/components/enrollment-provider/2-property-guest/P2PropertyAndGuests.vue');
const Badges = () => import('@/components/enrollment-provider/4-badges/P4Badges.vue');
const Booking = () => import('@/components/menu-parent/01-home/Booking.vue');
const EnrollChildcareProvider = () => import('@/components/enrollment-provider/EnrollChildcareProvider.vue');
const History = () => import('@/components/history/History.vue');
const ViewDetails = () => import('@/components/history/ViewDetails.vue');
const Users = () => import('@/components/admin/Users.vue');
const ChildrenAdmin = () => import('@/components/admin/ChildrenAdmin.vue');
const BookingInfoProvider = () => import('@/components/admin/BookingInfoProvider.vue');
const BookingInfoChild = () => import('@/components/admin/BookingInfoChild.vue');
const BookingHistoryParent = () => import('@/components/menu-parent/02-history/BookingHistoryParent.vue');
const BookingHistoryProvider = () => import('@/components/menu-provider/02-order-history/BookingHistoryProvider.vue');
const BookingTime = () => import('@/components/menu-parent/01-home/bookingTime/BookingTime.vue');
const ChooseBookingType = () => import('@/components/menu-parent/01-home/bookingTime/ChooseBookingType.vue');
const ReoccurringBookingDay = () => import('@/components/menu-parent/01-home/bookingTime/ReoccurringBookingDay.vue');
const BookingSummary = () => import('@/components/menu-parent/01-home/BookingSummary.vue');
const Page404 = () => import('@/components/error-pages/Page404.vue');
const EditProviderInfo = () => import('@/components/menu-provider/05-edit-enrollment/EditProviderInfo.vue');
const RegulationCompliance = () => import('@/components/menu-provider/03-regulation-compliance/RegulationCompliance.vue');
const PdfViewer = () => import('@/components/Viewer/PdfViewer.vue');

const Survey = () => import('@/components/survey/survey-main.vue');

//enrollmentForm
const EnrollmentFormParentLocationAutomation = () => import('@/components/location/LocationAutomation.vue');
const EnrollmentFormP0GetParentLocationAutomation = () => import('@/components/enrollment-parent/EnrollmentFormP0GetParentLocationAutomation.vue');
const ParentLocation = () => import('@/components/enrollment-parent/EnrollmentFormP1Location.vue');
const EnrollmentFormP2UserSettingsNotifications = () => import('@/components/enrollment-parent/EnrollmentFormP2UserSettingsNotifications.vue');
const EnrollmentFormP2ChildInfo = () => import('@/components/enrollment-parent/2-child-information/EnrollmentFormP2ChildInfo.vue');
const EnrollmentFormP3SchoolArrangement = () => import('@/components/enrollment-parent/3-school-arrangements/EnrollmentFormP3SchoolArrangement.vue');
const EnrollmentFormP4CustodyArrangement = () => import('@/components/enrollment-parent/4-custody-arrangements/EnrollmentFormP4CustodyArrangement.vue');
const EnrollmentFormP5EmergencyContacts = () => import('@/components/enrollment-parent/5-emegency-contacts/EnrollmentFormP5EmergencyContacts.vue');
const EnrollmentFormP6PickupPersons = () => import('@/components/enrollment-parent/6-pick-up-authorization/EnrollmentFormP6PickupPersons.vue');
const EnrollmentFormP7Immunization = () => import('@/components/enrollment-parent/7-immunization/EnrollmentFormP7Immunization.vue');
const EnrollmentFormP8HealthInformation = () => import('@/components/enrollment-parent/8-health-information/EnrollmentFormP8HealthInformation.vue');
const EnrollmentFormP9Allergy = () => import('@/components/enrollment-parent/9-allergy-information/EnrollmentFormP9Allergy.vue');
const EnrollmentFormP10SkinProducts = () => import('@/components/enrollment-parent/10-non-prescription-skin-products/EnrollmentFormP10SkinProducts.vue');
const EnrollmentFormP11FeedingArrangement = () => import('@/components/enrollment-parent/11-dietary-feeding-arrangements/EnrollmentFormP11FeedingArrangement.vue');
const EnrollmentFormP12PhysicalRequirements = () => import('@/components/enrollment-parent/12-physical-requirements/EnrollmentFormP12PhysicalRequirements.vue');
const EnrollmentFormP13SleepArrangements = () => import('@/components/enrollment-parent/13-sleep-arrangements/EnrollmentFormP13SleepArrangements.vue');
const EnrollmentFormP14AdditionalEmergencyInfo = () => import('@/components/enrollment-parent/14-additional-emergency/EnrollmentFormP14AdditionalEmergencyInfo.vue');
const EnrollmentFormP15AdditionalInfo = () => import('@/components/enrollment-parent/15-additional-information/EnrollmentFormP15AdditionalInfo.vue');

//Wait list
const MainPageWaitinglist = () => import('@/components/wait-list/MainPageWaitinglist.vue');
const WaitlistProviders = () => import('@/components/wait-list/WaitlistProviders.vue')

const ProviderType = () => import('@/components/wait-list/Parent/ProviderTypes.vue')
const ChildcareType = () => import('@/components/wait-list/Parent/ChildcareTypes.vue')
const SchoolPlanList = () => import('@/components/wait-list/Schools/SchoolPlanList.vue')
const SchoolPlanDetail = () => import('@/components/wait-list/Schools/SchoolPlanDetail.vue') 
const BigCalendar = () => import('@/components/wait-list/Parent/BigCalendar.vue')
const HourlyPay = () => import('@/components/wait-list/Parent/PaymentType/HourlyPay.vue')
const DailyPay = () => import('@/components/wait-list/Parent/PaymentType/DailyPay.vue')

const OneTimePurchase = () => import('@/components/wait-list/Parent/ModalPages/OneTimePurchase.vue')
const LimitPage = () => import('@/components/wait-list/Parent/ModalPages/LimitPage.vue')

const OptionSelection = () => import('@/components/wait-list/Parent/OptionSelect/OptionSelection.vue')
const ModalPage = () => import('@/components/wait-list/GeneralModalPage/ModalPage.vue')
const ModalPageClose = () => import('@/components/wait-list/GeneralModalPage/ModalPageClose.vue')
const WaitListCard = () => import('@/components/wait-list/Card/WaitListCard.vue')

const LocationAutomation = () => import('@/components/location/LocationAutomation.vue');
const P1StripeConnectedAccountLink = () => import('@/components/enrollment-provider/P1StripeConnectedAccountLink.vue');
const P2PropertyAndGuests = () => import('@/components/enrollment-provider/2-property-guest/P2PropertyAndGuests.vue');
const P3ProgramStatement = () => import('@/components/enrollment-provider/3-program-statement/P3ProgramStatement.vue');
const P4Badges = () => import('@/components/enrollment-provider/4-badges/P4Badges.vue');
const P5FamilyAmenities = () => import('@/components/enrollment-provider/5-family-amenities/P5FamilyAmenities.vue');
const P6HomeSafety = () => import('@/components/enrollment-provider/6-home-safety/P6HomeSafety.vue');
const P7GetLocationAutomation = () => import('@/components/enrollment-provider/7-get-location/P7GetLocationAutomation.vue');
const P8Location = () => import('@/components/enrollment-provider/8-location/P8Location.vue');
const P9HowParentsCanBook = () => import('@/components/enrollment-provider/9-how-parents-can-book/P9HowParentsCanBook.vue');
const P10AvailabilitySettings = () => import('@/components/enrollment-provider/10-availability-settings/P10AvailabilitySettings.vue');
const P11ChildrenRequirements = () => import('@/components/enrollment-provider/11-children-requirements/P11ChildrenRequirements.vue');
const P12HoursOfBusiness = () => import('@/components/enrollment-provider/12-hours-of-business/P12HoursOfBusiness.vue');
const P13Interviews = () => import('@/components/enrollment-provider/13-interviews/P13Interviews.vue');
const P13ConfirmLocation = () => import('@/components/enrollment-provider/13-interviews/P13ConfirmLocation.vue');
const P14Prices = () => import('@/components/enrollment-provider/14-prices/P14Prices.vue');
const P15CancellationPolicy = () => import('@/components/enrollment-provider/15-cancellation-policy/P15CancellationPolicy.vue');
const P16PoliciesAndProcedures = () => import('@/components/enrollment-provider/16-policies-and-procedures/P16PoliciesAndProcedures.vue');
const P17SettingsNotifications = () => import('@/components/enrollment-provider/17-settings-notification/P17SettingsNotifications.vue');

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'landing-home',
        component: LandingHome,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/about',
        name: 'about-us',
        component: LandingHomeAboutUs,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/blog',
        name: 'blog',
        component: LandingHomeBlog,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/blog/:id',
        name: 'blog-post',
        component: LandingHomeBlogPost,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/careers',
        name: 'careers',
        component: LandingHomeCareers,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/help',
        name: 'help',
        component: LandingHomeHelpCenter,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/licenses',
        name: 'licenses',
        component: LandingHomeLicenses,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/press',
        name: 'press',
        component: LandingHomePress,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/safety',
        name: 'safety',
        component: LandingHomeSafetyCenter,
        meta: {
            auth: false,
            layout: Layouts.landing
        },
    },
    {
        path: '/app',
        name: 'app',
        component: EmptyRouterView,
        children: [
            {
                path: 'surveys',
                component: EmptyRouterView,
                name: 'surveys',
                children: [
                    {
                        path: 'parents',
                        component: EmptyRouterView,
                        name: 'surveys-parents',
                        children: [
                            {
                                path: 'waitlist',
                                component: Survey,
                                name: 'parent-waitlist-survey',
                            }
                        ]
                    }
                ]
            },
            {
                path: 'waitlist/children/:childId/childcare-providers',
                component: WaitlistProviders,
                name: 'WaitlistProviders',
                children: [

                ]
            },
            {
                path: 'waitlist/waitlist-card',
                name: 'waitlist-card',
                component: WaitListCard,
                meta: { hideFooter: true, hideHeader: true },
                children: [
                    {
                        path: 'delete-confirm',
                        component: ModalPageClose,
                        meta: { hideFooter: true, hideHeader: true },
                    }
                ]
            },
            {
                path: 'register-supplement',
                name: 'register-supplement',
                component: RegisterSupplement,
                meta: {
                    auth: true,
                    layout: Layouts.application
                }
            },
            {
                name: 'application-home',
                path: 'home',
                component: ApplicationHome,
                // component: Booking,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                name: 'settings',
                path: 'settings',
                component: Settings,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "let-me-know",
                name: "let-me-know",
                component: LetMeKnow,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: 'parent-location-automation',
                name: 'parent-location-automation',
                component: EnrollmentFormParentLocationAutomation,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: 'get-parent-location-automation',
                name: 'get-parent-location-automation',
                component: EnrollmentFormP0GetParentLocationAutomation,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: 'parent-location',
                name: 'parent-location',
                component: ParentLocation,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: 'user-settings-notifications',
                name: 'user-settings-notifications',
                component: EnrollmentFormP2UserSettingsNotifications,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },    
            {
                path: "enroll",
                name: "enroll",
                component: EnrollmentForm,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent],
                    layout: Layouts.application
                },
                children: [
                    {
                        path: '',
                        name: 'child-info',
                        component: EnrollmentFormP2ChildInfo
                    },
                    {
                        path: 'school-arrangement',
                        name: 'school-arrangement',
                        component: EnrollmentFormP3SchoolArrangement
                    },
                    {
                        path: 'custody-arrangement',
                        name: 'custody-arrangement',
                        component: EnrollmentFormP4CustodyArrangement
                    },
                    {
                        path: 'emergency-contacts',
                        name: 'emergency-contacts',
                        component: EnrollmentFormP5EmergencyContacts
                    },
                    {
                        path: 'pickup-persons',
                        name: 'pickup-persons',
                        component: EnrollmentFormP6PickupPersons
                    },
                    {
                        path: 'immunization',
                        name: 'immunization',
                        component: EnrollmentFormP7Immunization
                    },
                    {
                        path: 'health-info',
                        name: 'health-info',
                        component: EnrollmentFormP8HealthInformation
                    },
                    {
                        path: 'allergy',
                        name: 'allergy',
                        component: EnrollmentFormP9Allergy
                    },
                    {
                        path: 'skin-products',
                        name: 'skin-products',
                        component: EnrollmentFormP10SkinProducts
                    },
                    {
                        path: 'feeding-arrangement',
                        name: 'feeding-arrangement',
                        component: EnrollmentFormP11FeedingArrangement
                    },
                    {
                        path: 'physical-requirements',
                        name: 'physical-requirements',
                        component: EnrollmentFormP12PhysicalRequirements
                    },
                    {
                        path: 'sleep-arrangements',
                        name: 'sleep-arrangements',
                        component: EnrollmentFormP13SleepArrangements
                    },
                    {
                        path: 'additional-emergency-info',
                        name: 'additional-emergency-info',
                        component: EnrollmentFormP14AdditionalEmergencyInfo
                    },
                    {
                        path: 'additional-info',
                        name: 'additional-info',
                        component: EnrollmentFormP15AdditionalInfo
                    }
                ]
            },
            {
                path: "enroll-childcare",
                name: "enroll-childcare",
                component: EnrollChildcareProvider,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent],
                    layout: Layouts.application
                },
                children: [
                    {
                        path: 'stripe-connected-account-link',
                        name: 'stripe-connected-account-link',
                        component: P1StripeConnectedAccountLink
                    },                    
                    {
                        path: 'property-and-guests',
                        name: 'property-and-guests',
                        component: P2PropertyAndGuests
                    },
                    {
                        path: 'program-statement',
                        name: 'program-statement',
                        component: P3ProgramStatement
                    },
                    {
                        path: 'badges',
                        name: 'badges',
                        component: P4Badges
                    },
                    {
                        path: 'family-amenities',
                        name: 'family-amenities',
                        component: P5FamilyAmenities
                    },
                    {
                        path: 'home-safety',
                        name: 'home-safety',
                        component: P6HomeSafety
                    },
                    {
                        path: 'get-location-automation',
                        name: 'get-location-automation',
                        component: P7GetLocationAutomation
                    },
                    {
                        path: 'location',
                        name: 'location',
                        component: P8Location
                    },
                    {
                        path: 'how-parents-can-book',
                        name: 'how-parents-can-book',
                        component: P9HowParentsCanBook
                    },
                    {
                        path: 'availability-settings',
                        name: 'availability-settings',
                        component: P10AvailabilitySettings
                    },
                    {
                        path: 'children-requirements',
                        name: 'children-requirements',
                        component: P11ChildrenRequirements
                    },
                    {
                        path: 'hours-of-business',
                        name: 'hours-of-business',
                        component: P12HoursOfBusiness
                    },
                    {
                        path: 'prices',
                        name: 'prices',
                        component: P14Prices
                    },
                    {
                        path: 'cancellation-policy',
                        name: 'cancellation-policy',
                        component: P15CancellationPolicy
                    },
                    {
                        path: 'policies-and-procedures',
                        name: 'policies-and-procedures',
                        component: P16PoliciesAndProcedures
                    },
                    {
                        path: 'settings-notifications',
                        name: 'settings-notifications',
                        component: P17SettingsNotifications
                    },
                ]
            },
            {
                path: "regulation-compliance",
                name: "regulation-compliance",
                component: RegulationCompliance,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "edit-provider-enrollment",
                name: "edit-provider",
                component: EditProviderInfo,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "congratulations",
                name: "congratulations",
                component: Congratulations,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "invitation-link",
                name: "invitation-link",
                component: InvitationLink,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "payment-info",
                name: "payment-info",
                component: PaymentInfo,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "payment-info-stripe",
                name: "payment-info-stripe",
                component: PaymentInfoStripe,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "credit-cards-list",
                name: "credit-cards-list",
                component: CreditCardsList,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "booking",
                name: "booking",
                component: Booking,
                props: true,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Nanny, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "/choose-booking-type",
                name: "choose-booking-type",
                component: ChooseBookingType,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "/reoccurring-booking-day",
                name: "reoccurring-booking-day",
                component: ReoccurringBookingDay,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "/booking-time",
                name: "booking-time",
                component: BookingTime,
                props: true,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "/booking-summary",
                name: "booking-summary",
                component: BookingSummary,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "enroll-childcare-provider",
                name: "enroll-childcare-provider",
                component: EnrollChildcareProvider,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "stripe-connected-account-link",
                name: "stripe-connected-account-link",
                component: StripeConnectedAccountLink,
                meta: {
                    auth: true,
                    roles: [Roles.HomeProvider, Roles.SuperAdmin],
                    layout: Layouts.application
                }
            },
            {
                path: "property-and-guests",
                name: "property-and-guests",
                component: PropertyAndGuests,
                meta: {
                    auth: true,
                    roles: [Roles.HomeProvider, Roles.SuperAdmin],
                    layout: Layouts.application
                }
            },
            {
                path: "home-safety",
                name: "home-safety",
                component: HomeSafety,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "get-location-automation",
                name: "get-location-automation",
                component: GetLocationAutomation,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "family-amenities",
                name: "family-amenities",
                component: FamilyAmenities,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "edit-profile",
                name: "edit-profile",
                component: EditProfile,
                meta: {
                    auth: true,
                    // roles: [Roles.SuperAdmin, Roles.HomeProvider, Roles.Parent], // admin has no dta in the profile
                    roles: [Roles.HomeProvider, Roles.Parent],
                    layout: Layouts.application
                }
            },
            {
                path: "settings-notifications",
                name: "settings-notifications",
                component: SettingsNotifications,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "policy-procedures",
                name: "policy-procedures",
                component: PolicysAndProcedures,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: 'badges',
                name: 'badges',
                component: Badges,
                meta: {
                    auth: true,
                    layout: Layouts.application,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider]
                }
            },
            {
                path: "program-statement",
                name: "program-statement",
                component: ProgramStatement,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "location",
                name: "location",
                component: Location,
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }
            },
            {
                path: "history",
                name: "history",
                component: History,
                children: [
                    {
                        path: 'viewDetails/:childId',
                        name: 'viewDetails',
                        component: ViewDetails
                    }
                ],
                meta: {
                    auth: true,
                    roles: [Roles.SuperAdmin, Roles.HomeProvider],
                    layout: Layouts.application
                }

            },
        ]
    },
    {
        path: '/waitlist/:id',
        component: MainPageWaitinglist,
        children: [
            {
                path: 'provider-type',
                component: ProviderType,
                name: 'ProviderTypes',
            },
            {
                path: 'childcare-type',
                component: ChildcareType,
            },
            {
                path: 'school-plan-list',
                component: SchoolPlanList,
                children: [
                    {
                        path: ':id',
                        name: 'SchoolPlanDetail',
                        component: SchoolPlanDetail,
                        props: true
                    },
                ]
            },
            {
                path: 'big-calendar',
                component: BigCalendar
            },
            // {
            //     path: 'hourly-payment',
            //     component: HourlyPay
            // },
            {
                path: 'daily-payment',
                component: DailyPay
            },
            {
                path: 'confirmation',
                component: ConfirmationPage
            },
            
        ]
    },
    {
        path: '/one-time-purchase',
        name: 'one-time-purchase',
        component: OneTimePurchase
    },
    {
        path: '/main-modal-page',
        component: ModalPage
    },
    {
        path: '/limit-page',
        component: LimitPage,
    },
    {
        path: "/error",
        name: "error",
        component: Error,
        props: true,
        meta: {
            auth: false
        }
    },
    {
        path: "/not-found",
        name: "404",
        component: Page404,
        meta: {
            auth: false
        }
    },
    {
        path: '/entry',
        component: Entry,
        children: [
            {
                path: 'login',
                name: 'login',
                component: Login,
                meta: {
                    auth: false,
                    layout: Layouts.entry
                }
            },
            {
                path: 'register',
                name: 'register',
                component: Register,
                meta: {
                    auth: false,
                    layout: Layouts.entry
                },
            }
        ]
    },
    {
        path: '/resetpassword',
        name: 'reset-password',
        component: ResetPassword,
        meta: {
            auth: false,
            layout: Layouts.entry
        }
    },
    {
        path: '/forgotpassword',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            auth: false,
            layout: Layouts.entry
        }
    },
    {
        path: '/emailnotconfirmed',
        name: 'email-not-confirmed',
        component: EmailNotConfirmed,
        meta: {
            auth: false,
            layout: Layouts.entry
        }
    },
    {
        path: "/surveycontainer",
        name: "survey-container",
        component: SurveyContainer,
        meta: {
            auth: true
        }
    },
    {
        path: "/cookie-policy",
        name: "cookie-policy",
        component: CookiePolicy,
        meta: {
            auth: false,
            //layout: Layouts.entry
            layout: Layouts.application
        }
    },
    {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: PrivacyPolicy,
        meta: {
            auth: false,
            //layout: Layouts.entry
            layout: Layouts.application
        }
    },
    {
        path: "/terms-of-use",
        name: "terms-of-use",
        component: TermsOfUse,
        meta: {
            auth: false,
            //layout: Layouts.entry
            layout: Layouts.application
        }
    },
    {
        path: "/orders-history",
        name: "orders-history",
        component: BookingHistoryProvider,
        meta: {
            auth: false,
            // layout: Layouts.entry
            layout: Layouts.application
        }
    },
    {
        path: "/bookings-history",
        name: "bookings-history",
        component: BookingHistoryParent,
        meta: {
            auth: false,
            // layout: Layouts.entry
            layout: Layouts.application
        }
    },
    {
        path: "/pdf-viewer",
        name: "pdf-viewer",
        component: PdfViewer,
        props: true,
        meta: {
            auth: false,
            // layout: Layouts.entry
            layout: Layouts.application
        }
    },

    /// -----    ADMIN     ---- ////
    {
        path: "/admin",
        component: EmptyRouterView,
        children: [{
            name: 'admin',
            path: '',
            component: AdminIndex,
            meta: {
                auth: true,
                // layout: Layouts.admin,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        {
            path: 'edit-privacy-policy',
            name: 'edit-privacy-policy',
            component: EditPrivacyPolicy,
            meta: {
                auth: true,
                // layout: Layouts.admin,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        {
            path: 'edit-terms-of-use',
            name: 'edit-terms-of-use',
            component: EditTermsOfUse,
            meta: {
                auth: true,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        {
            path: 'users',
            name: 'users',
            component: Users,
            meta: {
                auth: true,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        {
            path: 'children-admin',
            name: 'children-admin',
            component: ChildrenAdmin,
            meta: {
                auth: true,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        {
            path: 'booking-info-provider',
            name: 'booking-info-provider',
            component: BookingInfoProvider,
            meta: {
                auth: true,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        {
            path: 'booking-info-child',
            name: 'booking-info-child',
            component: BookingInfoChild,
            meta: {
                auth: true,
                layout: Layouts.application,
                roles: [Roles.SuperAdmin]
            }
        },
        ],
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to: any, from: any, next: any) => {
    const currRole: Number = UserPermissions.getCurrentRole();
    const enrolledChildren = UserPermissions.enrolledChildren();
    const addedCreditCard = UserPermissions.addedCreditCard();
    const numberInQueue: Number = UserPermissions.getNumberInQueue();
    // const completedRegisterInfo = UserPermissions.completedRegisterInfo();

    // if(currRole === Roles.Parent && to.path === "/app/enroll" && !completedRegisterInfo){
    //     return next('/app/register-supplement');
    // }

    //z
    // if (currRole === Roles.Parent && to.name === 'choose-booking-type' && numberInQueue > 1) {
    //     return next('/app/congratulations');
    // }

    if (currRole === Roles.Parent && to.name === 'enroll' && enrolledChildren && !addedCreditCard) {
        return next('/app/payment-info');
    }

    if (to.meta.auth && currRole === -1) {
        return next("/entry/login");
    }

    if (to.meta.roles && !to.meta.roles?.includes(currRole)) {
        return next("/not-found");
    }

    if (to.matched.length === 0) {
        return next("/not-found");
    }

    const rt = customLocalStorage.getItem("rt");
    const entryPages = ['/entry/login', '/entry/register'];

    if (entryPages.includes(to.path) && !to.query.hasOwnProperty('rt')
        && rt && !to.query.hasOwnProperty('etoken')) {

        return next({ path: to.path, query: { rt: rt } });
    }

    const isLogOut = customLocalStorage.getItem("isLogOut");
    if (isLogOut === 'true') {
        customLocalStorage.setItem("isLogOut", "false");

        UserPermissions.logout(store.dispatch, router, "/entry/register");
    }

    return(next());
});

export default router;